import { lazyLoad } from '@/lib/LazyLoad';

export const DiscordDetailPage = lazyLoad(
  () => import('./DiscordDetailPage'),
  (module) => module.DiscordDetailPage
);
